module.exports = __webpack_public_path__ + "img/mute.8202565a.svg";